// Antes das rotas aninhadas, o admin usava abas na query string
// (/admin?aba=billing&secao=convites). Links salvos continuam funcionando:
// esta função devolve a seção nova equivalente.
export function legacyAdminPath(params: URLSearchParams): string {
  if (params.get("aba") !== "billing") return "medicos";

  const secao = params.get("secao");
  if (secao === "convites") return "links-de-pagamento";
  if (secao === "cortesia") return "parcerias";
  return "clinicas-assinantes";
}
